
(function() {
  var result = { translations: { "en": null } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "signup-ui-lego": {
    "da": "static-1.8369",
    "de": "static-1.8369",
    "en": "static-1.8369",
    "es": "static-1.8369",
    "fi": "static-1.8369",
    "fr": "static-1.8369",
    "it": "static-1.8369",
    "ja": "static-1.8369",
    "nl": "static-1.8369",
    "no": "static-1.8369",
    "pl": "static-1.8369",
    "pt-br": "static-1.8369",
    "sv": "static-1.8369",
    "zh-tw": "static-1.8369"
  }
};
  hns('I18n', result);

})();


